module.exports = __webpack_public_path__ + "img/sarah-p-wills.1cf62c38.png";